
  window.tovConfig = {
    // 1. Initialize identity and login status
    isLoggedIn: false,
    customerId: null,
    customerEmail: null,
    // 2. Map Liquid template name to your pageType logic
    pageType: (function() {
      return null;
    })(),
    //shop_id: null,
    //shop_name: null
  };

(function() {
  if (window.tovRepairQuery && window.tovRepairQuery()) return;
//get pathaname from url and check if current url is from /search or /app/search page then we skip the execution 
  const currentPath = window.location.pathname;
  const isSearchPage = currentPath === '/search' || currentPath === '/apps/search';
  if(isSearchPage) {
    return; // Only skip on search pages
  }

  // 1. Force Split (ui= variant) extraction
  const urlParams = new URLSearchParams(window.location.search);
  const uiParam = urlParams.get('ui');
  const forceSplit = uiParam ? `?ui=${uiParam}` : '';

  // 2. Prepare Context
  function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

const shopifyY = getCookie('shopify_client_id');
const shopifyS = getCookie('shopify_client_id');


  const heartbeatContext = {
    event_name: "heartbeat",
    timestamp: Date.now(),
    anonymous_id: shopifyY, // Using cookie ID as anonymous_id
    user_id: window.tovConfig.customerId,
    customer_email: window.tovConfig.customerEmail,
    url: window.location.href,
    referrer: document.referrer,
  };

  // 3. Execute Fetch
  fetch(`https://app.tovfurniture.com/api/split-test/heartbeat${forceSplit}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Session-ID': shopifyS,
      'X-Shopify-Client-ID': shopifyY,
      'X-Shopify-Page-Type': window.__PAGE_TYPE__,
      'X-Store-ID': window.__SHOP_ID__,
      'X-Store-Name': window.__SHOP_NAME__,
    },
    keepalive: true,
    body: JSON.stringify(heartbeatContext),
  })
  .then(response => response.json())
  .then(result => {
    if (result?.data?.split_testing?.enabled) {
      const activeVariants = result.data.split_testing.current_variants;
      
      for (const key in activeVariants) {
        const aVariant = activeVariants[key];
        // SAVE: Using real localStorage with 'tov-st-' prefix
        localStorage.setItem(
          'tov-st-' + aVariant.experimentName,
          JSON.stringify(aVariant)
        );
      }
      
      // Optional: Dispatch event so your theme sections can react immediately
      window.dispatchEvent(new CustomEvent('tov:variants_loaded', { detail: activeVariants }));
      console.log('Split Test Data Saved:', activeVariants);
    }
  })
  .catch(err => console.error("Heartbeat Error:", err));
})();
